
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make",
      function () {
        return require("private-next-pages/make/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make"])
      });
    }
  